import { render, staticRenderFns } from "./MultipleGuardianSelecet.vue?vue&type=template&id=17907d80&scoped=true&"
import script from "./MultipleGuardianSelecet.vue?vue&type=script&lang=js&"
export * from "./MultipleGuardianSelecet.vue?vue&type=script&lang=js&"
import style0 from "./MultipleGuardianSelecet.vue?vue&type=style&index=0&id=17907d80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17907d80",
  null
  
)

export default component.exports